import { createContext } from "react";

/**
 * Provides the live list of modules + a refetch function.
 *
 * Value shape: { modules: Array<{ id, name, is_active }> | null, refetch: () => void }
 *
 * `modules === null` means the fetch hasn't completed yet. treat every module
 * as active in that case so nothing flickers on load.
 */
export const ModulesContext = createContext({ modules: null, refetch: () => {} });

/**
 * Returns true if the module is active (or not yet loaded).
 * Modules without a matching id default to visible.
 */
export const isModuleActive = (modules, moduleId) => {
  if (!modules) return true; // loading. show everything
  const mod = modules.find((m) => m.id === moduleId);
  return mod ? Boolean(mod.is_active) : true;
};
